// extracted by mini-css-extract-plugin
module.exports = {"link_list":"styles_link_list__zWFfr","contains_arrow_icons":"styles_contains_arrow_icons__jDTmi"};